'use client';

import React, { useState, useEffect } from 'react';


interface FAQ {
  id: string;
  question: string;
  answer: string;
  category: string;
}

interface FAQSectionProps {
  className?: string;
}

const FAQSection = ({ className = '' }: FAQSectionProps) => {
  const [isHydrated, setIsHydrated] = useState(false);
  const [openFAQ, setOpenFAQ] = useState<string | null>(null);
  const [activeCategory, setActiveCategory] = useState<string>('all');

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const faqs: FAQ[] = [
  {
    id: 'faq1',
    question: 'What is your typical response time for inquiries?',
    answer: 'Response times vary by inquiry type: Product Trading inquiries receive responses within 4 hours, Regulatory Consultancy within 2 hours during business hours, Technical Support within 6 hours, and Partnership inquiries within 24 hours. Emergency support is available 24/7 with immediate response.',
    category: 'general'
  },
  {
    id: 'faq2',
    question: 'Which countries do you currently serve?',
    answer: 'We serve 60+ countries across six continents, with established offices in India, UAE, UK, and Brazil. Our regulatory expertise covers EU-GMP, WHO-GMP, ANVISA, and other major regulatory frameworks. Contact us to confirm service availability in your specific region.',
    category: 'general'
  },
  {
    id: 'faq3',
    question: 'How do I request product samples or specifications?',
    answer: 'Product samples and detailed specifications can be requested through our Technical Support channel (technical@ashabpharma.com) or via the contact form selecting "Product Trading Inquiry". Include your company details, intended market, and specific product requirements for fastest processing.',
    category: 'products'
  },
  {
    id: 'faq4',
    question: 'What documentation do you provide for regulatory submissions?',
    answer: 'We provide comprehensive regulatory documentation including Certificates of Analysis, Manufacturing Licenses, GMP Certificates, Stability Data, DMFs (Drug Master Files), and country-specific dossiers. All documentation meets international regulatory standards and is available in multiple languages.',
    category: 'regulatory'
  },
  {
    id: 'faq5',
    question: 'Do you offer regulatory consultancy for market entry?',
    answer: 'Yes, our Regulatory Consultancy Services team specializes in market entry strategies, dossier preparation, regulatory submissions, and compliance audits. We have successfully supported market entry in 60+ countries with expertise in major regulatory frameworks including EU, WHO, ANVISA, and FDA.',
    category: 'regulatory'
  },
  {
    id: 'faq6',
    question: 'What are your minimum order quantities?',
    answer: 'Minimum order quantities vary by product category and destination market. Contact our Product Trading team with specific product requirements for detailed MOQ information and pricing. We accommodate both large-scale institutional orders and smaller trial quantities for new partnerships.',
    category: 'products'
  },
  {
    id: 'faq7',
    question: 'How can I become a distribution partner?',
    answer: 'Distribution partnership opportunities are available for qualified pharmaceutical distributors. Contact our Partnership team (partnerships@ashabpharma.com) with your company profile, target markets, and distribution capabilities. We evaluate partnerships based on regulatory compliance, market presence, and strategic alignment.',
    category: 'partnership'
  },
  {
    id: 'faq8',
    question: 'What quality certifications do you hold?',
    answer: 'Our manufacturing partners hold EU-GMP, WHO-GMP, ISO 9001:2024, and ANVISA certifications. We maintain rigorous quality standards across all products and undergo regular audits by international regulatory authorities. Detailed certification documentation is available upon request.',
    category: 'regulatory'
  }];


  const categories = [
  { value: 'all', label: 'All Questions', icon: 'QuestionMarkCircleIcon' },
  { value: 'general', label: 'General', icon: 'InformationCircleIcon' },
  { value: 'products', label: 'Products', icon: 'CubeIcon' },
  { value: 'regulatory', label: 'Regulatory', icon: 'DocumentCheckIcon' },
  { value: 'partnership', label: 'Partnership', icon: 'HandRaisedIcon' }];


  const filteredFAQs = activeCategory === 'all' ?
  faqs :
  faqs.filter((faq) => faq.category === activeCategory);

  const toggleFAQ = (id: string) => {
    setOpenFAQ(openFAQ === id ? null : id);
  };

  if (!isHydrated) {
    return (
      <section className={`py-16 bg-muted ${className}`}>
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="animate-pulse space-y-4">
              <div className="h-8 bg-card rounded w-3/4 mx-auto"></div>
              <div className="h-4 bg-card rounded w-1/2 mx-auto"></div>
              <div className="space-y-3 mt-8">
                {[1, 2, 3].map((i) =>
                <div key={i} className="h-16 bg-card rounded"></div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>);

  }

  return;



























































































};

export default FAQSection;